export default {
  name: 'user-online',
  components: {},
  props: [],
  data () {
    return {
      system: {
        fullname: '',
        avatar: '',
        id: 0
      }
    }
  },
  computed: {
    users () {
      return this.$store.getters['User/getUserOnline']
    }
  },
  mounted () {
    this.$loading.start()
    this.$store.dispatch('User/getUserOnline').then(res => {
      this.$loading.complete()
    }).catch(errors => {
      this.$loading.fail()
    })
  },
  methods: {
    chat (user) {
      document.body.classList.toggle('aside-menu-hidden')
      this.$store.dispatch('Chat/insertNewWindownChat', user)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/user-online/user-online.js